module.exports = __webpack_public_path__ + "img/hierarchy-6.4b9f2542.svg";